// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entitlements {
  width: 100%;
  height: 40vh;
  overflow-y: scroll;
  font-family: inherit;
}

.group-node {
  display: flex;
  align-items: center;
  padding-left: 8px;
  margin: 2px 0;
}

.group-node > span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  margin-right: 4px;
}

.group-children {
  position: relative;
  margin-left: 16px;
  padding-left: 16px;
}

.group-children::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 1px;
  background: repeating-linear-gradient(to bottom, #999, #999 2px, transparent 2px, transparent 4px);
}

/* Child entitlement */
.group-children .checkbox {
  display: flex;
  align-items: center;
  margin: 2px 0;
  padding-left: 22px;
  padding-right: 12px;
  position: relative;
}

/* Dotted horizontal connector */
.group-children .checkbox::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  width: 25px;
  height: 1px;
  background-image: repeating-linear-gradient(to right, #999, #999 2px, transparent 1px, transparent 3px);
  background-repeat: repeat-x;
  background-size: auto;
  transform: translateY(-50%);
}

/* Mask vertical line after last child */
.group-children .checkbox:last-child::after {
  content: "";
  position: absolute;
  left: -16px;
  top: 50%;
  bottom: 0;
  width: 1px;
  background: #fff;
}

.ungrouped-item {
  display: flex;
  align-items: center;
  margin: 2px 0;
}

.group-node,
.group-children .checkbox,
.ungrouped-item {
  margin: 0;
  padding-top: 2px;
  padding-bottom: 2px;
  min-height: 28px;
}

.group-node > span {
  width: 20px;
  margin-right: 4px;
}

.entitlement-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-weight: bold;
}

.entitlement-enabled {
  width: 4em;
  text-align: center;
}

.entitlement-Include {
  width: 4em;
  text-align: left;
}

.entitlement-display-name {
  flex: 1;
  text-align: left;
}

.entitlement-box {
  padding: 10px 20px;
  border: 1px solid #e8e6e6;
  border-radius: 4px;
  background-color: #fff;
}

.mat-mdc-slide-toggle.mat-accent {
  --mdc-switch-selected-focus-state-layer-color: #00677f;
  --mdc-switch-selected-handle-color: #00677f;
  --mdc-switch-selected-hover-state-layer-color: #00677f;
  --mdc-switch-selected-pressed-state-layer-color: #00677f;
  --mdc-switch-selected-focus-handle-color: #00677f;
  --mdc-switch-selected-hover-handle-color: #00677f;
  --mdc-switch-selected-pressed-handle-color: #00677f;
  --mdc-switch-selected-focus-track-color: #477781;
  --mdc-switch-selected-hover-track-color: #477781;
  --mdc-switch-selected-pressed-track-color: #477781;
  --mdc-switch-selected-track-color: #477781;
}

.group-children .group-children-leaf {
  display: flex;
  align-items: left;
  width: 100%;
  padding-right: 0px;
  padding-left: 2px;
  min-height: 41px;
}

.single-entitlement {
  min-height: 41px;
}`, "",{"version":3,"sources":["webpack://./src/app/organizations/org-entitlements/org-entitlements.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,kGAAA;AAAF;;AASA,sBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AANF;;AASA,gCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,uGAAA;EAOA,2BAAA;EACA,qBAAA;EACA,2BAAA;AAZF;;AAeA,wCAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAZF;;AAeA;;;EAGE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,WAAA;EACA,iBAAA;AAZF;;AAcA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;AAXF;;AAaA;EACE,UAAA;EACA,kBAAA;AAVF;;AAYA;EACE,UAAA;EACA,gBAAA;AATF;;AAWA;EACE,OAAA;EACA,gBAAA;AARF;;AAWA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AARF;;AAWA;EACI,sDAAA;EACA,2CAAA;EACA,sDAAA;EACA,wDAAA;EACA,iDAAA;EACA,iDAAA;EACA,mDAAA;EACA,gDAAA;EACA,gDAAA;EACA,kDAAA;EACA,0CAAA;AARJ;;AAWA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF","sourcesContent":[".entitlements {\n  width: 100%;\n  height: 40vh;\n  overflow-y: scroll;\n  font-family: inherit;\n  \n}\n\n.group-node {\n  display: flex;\n  align-items: center;\n  padding-left: 8px;\n  margin: 2px 0;\n}\n\n.group-node > span {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 24px;\n  margin-right: 4px;\n}\n\n.group-children {\n  position: relative;\n  margin-left: 16px;\n  padding-left: 16px;\n}\n\n.group-children::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 1px;\n  background: repeating-linear-gradient(\n    to bottom,\n    #999,\n    #999 2px,\n    transparent 2px,\n    transparent 4px\n  );\n}\n\n/* Child entitlement */\n.group-children .checkbox {\n  display: flex;\n  align-items: center;\n  margin: 2px 0;\n  padding-left: 22px;\n  padding-right: 12px;\n  position: relative;\n}\n\n/* Dotted horizontal connector */\n.group-children .checkbox::before {\n  content: '';\n  position: absolute;\n  left: -15px;\n  top: 50%;\n  width: 25px;\n  height: 1px;\n  background-image: repeating-linear-gradient(\n    to right,\n    #999,\n    #999 2px,\n    transparent 1px,\n    transparent 3px\n  );\n  background-repeat: repeat-x;\n  background-size: auto;\n  transform: translateY(-50%);\n}\n\n/* Mask vertical line after last child */\n.group-children .checkbox:last-child::after {\n  content: '';\n  position: absolute;\n  left: -16px;\n  top: 50%;\n  bottom: 0;\n  width: 1px;\n  background: #fff; \n}\n\n.ungrouped-item {\n  display: flex;\n  align-items: center;\n  margin: 2px 0;\n}\n\n.group-node,\n.group-children .checkbox,\n.ungrouped-item {\n  margin: 0;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  min-height: 28px;\n}\n\n.group-node > span {\n  width: 20px;\n  margin-right: 4px;\n}\n.entitlement-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  font-weight: bold;\n}\n.entitlement-enabled{\n  width: 4em;\n  text-align: center;\n}\n.entitlement-Include {\n  width: 4em;\n  text-align: left;\n}\n.entitlement-display-name {\n  flex: 1;\n  text-align: left;\n}\n\n.entitlement-box {\n  padding: 10px 20px;\n  border: 1px solid #e8e6e6;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.mat-mdc-slide-toggle.mat-accent {\n    --mdc-switch-selected-focus-state-layer-color: #00677f;\n    --mdc-switch-selected-handle-color: #00677f;\n    --mdc-switch-selected-hover-state-layer-color: #00677f;\n    --mdc-switch-selected-pressed-state-layer-color: #00677f;\n    --mdc-switch-selected-focus-handle-color: #00677f;\n    --mdc-switch-selected-hover-handle-color: #00677f;\n    --mdc-switch-selected-pressed-handle-color: #00677f;\n    --mdc-switch-selected-focus-track-color: #477781;\n    --mdc-switch-selected-hover-track-color: #477781;\n    --mdc-switch-selected-pressed-track-color: #477781;\n    --mdc-switch-selected-track-color: #477781;\n}\n\n.group-children .group-children-leaf {\n  display:flex;\n  align-items: left; \n  width:100%; \n  padding-right: 0px;\n  padding-left:2px;\n  min-height:41px\n}\n\n.single-entitlement{\n  min-height: 41px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
